import React, { useState } from 'react'

const User = React.createContext()

export function UserContext(props) {
    const [state, setState] = useState()
    return <User.Provider value={[state, setState]}>{props.children}</User.Provider>
}

export default User